/**
 * ReasonChart — Section 2: Total Alarms by Reason (bar chart).
 */

import { useRef, useEffect } from 'react';
import { Chart, registerables } from 'chart.js';
import { useChartSeries } from '../../../../components/charts/chartPalette.js';

Chart.register(...registerables);

const ReasonChart = ({ reasonData }) => {
    const COLORS = useChartSeries();
    const canvasRef = useRef(null);
    const chartRef = useRef(null);

    useEffect(() => {
        if (!canvasRef.current) return;
        const labels = reasonData?.labels || [];
        const totals = reasonData?.totals || [];

        if (labels.length === 0) {
            if (chartRef.current) { chartRef.current.destroy(); chartRef.current = null; }
            return;
        }

        const bgColors = labels.map((_, i) => COLORS[i % COLORS.length]);

        if (chartRef.current) {
            chartRef.current.data.labels = labels;
            chartRef.current.data.datasets[0].data = totals;
            chartRef.current.data.datasets[0].backgroundColor = bgColors;
            chartRef.current.update();
        } else {
            chartRef.current = new Chart(canvasRef.current, {
                type: 'bar',
                data: {
                    labels,
                    datasets: [{
                        label: 'Alarms',
                        data: totals,
                        backgroundColor: bgColors,
                        borderRadius: 5,
                    }],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            callbacks: {
                                label: (ctx) => ` ${ctx.formattedValue} Alarms`,
                            },
                        },
                    },
                    scales: {
                        x: { grid: { display: false } },
                        y: { grid: { display: false }, title: { display: true, text: 'Alarms' } },
                    },
                },
            });
        }

        return () => {
            if (chartRef.current) { chartRef.current.destroy(); chartRef.current = null; }
        };
    }, [reasonData, COLORS]);

    const hasData = reasonData?.labels?.length > 0;

    if (!hasData) return null;

    return (
        <div className="ex-section">
            <h3 className="ex-section__title">Total Alarms by Reason</h3>
            <div className="ex-chart-container">
                <canvas ref={canvasRef} />
            </div>
        </div>
    );
};

export default ReasonChart;
